


import { useEffect, useState } from 'react';



function getPresentationModeIframe() {

  if (typeof window === 'undefined') {
    // Defensive: not running in browser (SSR/server-side)
    return 0;
  }

  try {

    // 0 == Normal desktop web
    // 1 == iFrame
    // 1 == Cross-origin iframe (blocked access to window.top)
    // 0 == Server-side render (no window)

    // if 1, the expand/fullscreen button should be "expanded".
    // if 0, the expand/fullscreen button should be "fullscreen".

    return window.self !== window.top ? 1 : 0;
  }
  catch (e) {
    // Some browsers block access to window.top (e.g., cross-origin iframes)
    return 1;
  }
}



function getPresentationModeSize() {

  //return 1;  // For testing only...

  const width = window.innerWidth;
  const height = window.innerHeight;

  if (height < 600) {
    // Left sidebar expanded by default, right sidebar collapsed.
    return 5;  // Super short, so straight to mobile mode (ie iPhone on it's side - it's wide but a bit useless).
  }

  if (width > 1024) {
    // Both sidebars should be expanded by default.
    return 1;  // Desktop - big.
  }
  if (width > 768) {
    // Both sidebars expanded.
    return 2;  // Decent sized tablet / small laptop
  }
  if (width > 650) {
    // Left sidebar expanded by default, right sidebar collapsed.
    return 3;  // Small tablet
  }
  if (width > 480) {
    // Left sidebar expanded by default, right sidebar collapsed.
    return 4;  // Mobile phone size
  }

  // Left sidebar expanded by default, right sidebar collapsed.
  return 5;  // Tiineeee...
}


export default function useUIPresentationMode() {

  const [presentationModeSize, setSize] = useState(getPresentationModeSize());
  const [presentationModeiFrame, setIframe] = useState(getPresentationModeIframe());

  useEffect(() => {

    const handleResize = () => {

      setSize(getPresentationModeSize());
      setIframe(getPresentationModeIframe());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { presentationModeSize, presentationModeiFrame };
}


